import { required, minLength, maxLength } from "vuelidate/lib/validators";

import debounce from "lodash/debounce";

import {
  UPDATE_USER_PHONE,
  CHECK_USER_LOGIN,
  CONFIRM_USER_PHONE,
  RESENT_PHONE_PIN
} from "./gql/UpdateUser";

export default {
  name: "user_phone_control",

  props: ["phone"],

  data() {
    return {
      isPhoneAdded: false,

      login: this.phone,
      password: "",
      code: "",
      isShowPhoneForm: false,
      submitPhoneLoading: false,
      isShowSmsCodeForm: false,

      skipCheckLoginQuery: true,
      checkLogin: "",

      isSubmitCode: false,
      isFinishedTimer: false,

      submitResendPinLoading: false
    };
  },

  watch: {
    phone: function(newV) {
      if (newV) {
        this.login = newV;
        this.isPhoneAdded = true;
      }
    }
  },

  mounted: function() {
    if (this.phone) {
      this.isPhoneAdded = true;
    }
  },

  apollo: {
    checkLogin: {
      query: CHECK_USER_LOGIN,
      variables() {
        return {
          login: this.login
        };
      },

      skip() {
        return this.skipCheckLoginQuery;
      },

      result() {
        this.skipCheckLoginQuery = true;
      }
    }
  },

  validations() {
    let params = {
      login: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(256)
      },
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(16)
      }
    };

    if (this.isShowSmsCodeForm) {
      params.code = {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)
      };
    }

    return params;
  },

  methods: {
    addNewPhone() {
      this.login = "";
      this.isShowPhoneForm = true;
      this.isPhoneAdded = false;
    },

    hidePhoneForm() {
      this.isShowPhoneForm = false;
      this.isPhoneAdded = !!this.phone;
    },

    submitPhoneForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitPhoneLoading = true;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_PHONE,
            variables: {
              phone: this.login,
              currentPassword: this.password
            }
          })
          .then(({ data }) => {
            this.isShowSmsCodeForm = true;
            this.password = "";
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }
          })
          .finally(() => {
            this.submitPhoneLoading = false;
          });
      }
    },

    handleCheckLogin: debounce(function() {
      this.skipCheckLoginQuery = false;
    }, 100),

    submitSmsCode() {
      this.isSubmitCode = true;

      this.$apollo
        .mutate({
          mutation: CONFIRM_USER_PHONE,
          variables: {
            phone: this.login,
            pin: this.code
          }
        })
        .then(({ data: { confirmUserPhone: { accessToken, user } } }) => {
          if (typeof localStorage !== "undefined" && accessToken) {
            localStorage.setItem("AUTH_TOKEN", accessToken);
          }

          this.$store.commit("setUserPhone", user.phone);
          this.isShowPhoneForm = false;
          this.isShowSmsCodeForm = false;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.isSubmitCode = false;
        });
    },

    finishedTimer() {
      this.isFinishedTimer = true;
    },

    resendPhonePin() {
      this.submitResendPinLoading = true;

      this.$apollo
        .mutate({
          mutation: RESENT_PHONE_PIN,
          variables: {
            phone: this.login
          }
        })
        .then(({ data }) => {
          this.code = "";
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitResendPinLoading = false;

          this.$refs.vac.startCountdown(true);
          this.isFinishedTimer = false;
        });
    }
  },

  components: {}
};
